module.exports = __webpack_public_path__ + "static/media/section5.1d3c401a.png";